import React from 'react'
import { differenceInMinutes, format } from 'date-fns'
import { useTheme } from '@chakra-ui/react'
import { Box, Text } from '@chakra-ui/react'
import { TimeInterval } from '~graphql/generated/graphql'

export const UnavailableBlock: React.FC<{
    block: TimeInterval
    startTime: number
    endTime: number
    index: number
    spacing?: number
}> = ({ block, startTime, endTime, index, spacing = 56 }) => {
    const theme = useTheme()

    const startDate = new Date(block.start || 0)
    const endDate = new Date(block.end || 0)

    const bg = `repeating-linear-gradient(
                45deg,
                rgba(0,0,0,0),
                rgba(0,0,0,0) 10px,
                rgba(0,0,0,0.05) 10px,
                rgba(0,0,0,0.05) 20px
                ),
                ${theme.colors.blackAlpha[100]};`
    const color = 'rgba(0, 0, 0, 0.5)'

    const startHours = startDate.getHours()
    const startMinutes = startDate.getMinutes()

    const top =
        ((startHours - Math.floor(startTime)) * 4 + startMinutes / 15) *
        spacing +
        2
    const left = 0

    const MIN_HEIGHT = 48
    const height = (differenceInMinutes(endDate, startDate) * spacing) / 15 - 3

    return (
        <>
            <Box
                key={'appt' + index}
                position="absolute"
                top={`${top}px`}
                left={left * 100 + '%'}
                w="100%"
                px={1}
                role="group"
                transition="0.1s"
                zIndex={-1}
            >
                <Box
                    bg={bg}
                    w="full"
                    // minH={`${24}px`}
                    height={`${height}px`}
                    overflow="hidden"
                    _hover={{ maxH: '100%', zIndex: 1 }}
                    rounded="md"
                    textAlign="left"
                >
                    {/* {height > MIN_HEIGHT && (
                        <Box
                            w="100%"
                            h="12px"
                            // bg="brand.500"
                            bg={bg}
                            filter="contrast(0.83) saturate(2.03) brightness(0.86)"
                        ></Box>
                    )} */}
                    <Box pt={height > MIN_HEIGHT ? 2 : 1} px={4} pb={3}>
                        <Text
                            color={color}
                            letterSpacing="wide"
                            fontWeight="bold"
                            fontSize={height > MIN_HEIGHT ? '14px' : '12px'}
                            lineHeight={'17px'}
                        >
                            Unavailable
                        </Text>
                        <Text
                            color={color}
                            fontSize="13px"
                            fontWeight="semibold"
                        >
                            {format(startDate, 'h:mm a')} -{' '}
                            {format(endDate, 'h:mm a')}
                        </Text>
                    </Box>
                </Box>
            </Box>
        </>
    )
}
